export default __webpack_public_path__ + "static/media/list-hc.c4a0103e.svg";